import { FC } from 'react';
import { Centered } from './centered';
import { Text, Spinner } from '@servicetitan/anvil2';

interface LoaderProps {
    fullPage?: boolean;
    text?: string;
    className?: string;
}

export const Loader: FC<LoaderProps> = props => {
    const { fullPage, text, className } = props;

    return (
        <Centered fullPage={fullPage} className={className}>
            <Spinner />
            <Text variant="body" subdued className="m-block-start-2">
                {text ?? 'Loading'}
            </Text>
        </Centered>
    );
};
